import { FileSnapshot } from "@/entities/DataAssociation/File.model";
import { formatDate } from "@/utils/misc/format";
import clsx from "clsx";
import { FileIcon } from "./FileIcon";

export function FileMeta({
    file,
    condensed = false,
}: {
    file: FileSnapshot;
    condensed?: boolean;
}) {
    return (
        <div className="flex items-center gap-2">
            <FileIcon file={file} condensed={condensed} />

            {" · "}

            <p
                className={clsx(
                    "subdued",
                    "body-s flex cursor-pointer items-center gap-1 italic",
                )}
            >
                {"Created"}{" "}
                {formatDate(file.createdAt, {
                    hideTime: true,
                    dateFormat: "YYYY-MM-DDTHH:mm:ssZ",
                })}
            </p>
        </div>
    );
}
